import React, { useState } from "react";
import styled from "styled-components";
import { IconButton } from "components/common";
import { Row, Badge } from "common/components";
import AssetLink from "security-app/components/Assets/plugin/AssocAssetsWidget/AssetLink";
import SidebarNavigationLink from "components/layout/RightSidebar/SidebarNavigationLink";
import SidebarInvestigationDetails from "security-app/components/Investigations/Details/SidebarInvestigationDetails";
const CollapsibleRow = styled(Row)`
  max-height: ${({ $isExpanded }) => $isExpanded ? "400px" : "auto"};
  overflow: ${({ $isExpanded }) => $isExpanded ? "auto" : "hidden"};
  text-overflow: ellipsis;
  white-space: ${({ $isExpanded }) => $isExpanded ? "wrap" : "nowrap"};
`;
function CellWrapper({ isExpanded, setIsExpanded, entities, children }) {
  return /* @__PURE__ */ React.createElement(Row, { style: { whiteSpace: "nowrap" } }, entities.length > 1 && /* @__PURE__ */ React.createElement(
    IconButton,
    {
      title: "Toggle associated entities",
      name: isExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down",
      onClick: () => setIsExpanded(!isExpanded)
    }
  ), /* @__PURE__ */ React.createElement(CollapsibleRow, { $wrap: isExpanded, $isExpanded: isExpanded, $gap: isExpanded ? "sm" : "xs" }, children), !isExpanded && entities.length > 1 && /* @__PURE__ */ React.createElement(Badge, null, "+ ", entities.length - 1));
}
export function InvestigationsCell({ investigations = [] }) {
  const [isExpanded, setIsExpanded] = useState(false);
  if (investigations.length === 0) return null;
  let sortedInvestigations = [...investigations].sort((a, b) => a.name.localeCompare(b.name));
  if (!isExpanded && sortedInvestigations.length > 1) sortedInvestigations = sortedInvestigations.slice(0, 1);
  return /* @__PURE__ */ React.createElement(CellWrapper, { isExpanded, setIsExpanded, entities: investigations }, sortedInvestigations.map((investigation) => /* @__PURE__ */ React.createElement(
    SidebarNavigationLink,
    {
      key: `investigation-${investigation.id}-link`,
      content: SidebarInvestigationDetails(investigation.id)
    },
    investigation.name
  )));
}
export function AssociatedAssetsCell({ assets = [] }) {
  const [isExpanded, setIsExpanded] = useState(false);
  if (assets.length === 0) return null;
  let sortedAssets = [...assets].sort((a, b) => a.name.localeCompare(b.name));
  if (!isExpanded && sortedAssets.length > 1) sortedAssets = sortedAssets.slice(0, 1);
  return /* @__PURE__ */ React.createElement(CellWrapper, { isExpanded, setIsExpanded, entities: assets }, sortedAssets.map(
    (asset) => asset.id ? /* @__PURE__ */ React.createElement(AssetLink, { key: asset.id, asset }) : /* @__PURE__ */ React.createElement("span", { key: asset.name }, asset.name)
  ));
}
